// SellerProfile.jsx - Estate Experts Seller Profile
import React, { useState, useContext } from 'react';
import {
  FiEdit2,
  FiSave,
  FiX,
  FiMapPin,
  FiCamera,
  FiCheck,
  FiUser,
  FiMail,
  FiPhone,
  FiBriefcase,
  FiShield,
  FiCalendar,
  FiArrowLeft
} from 'react-icons/fi';
import '../../../assets/css/sellers/dashboard/sellerprofile/sellerprofile.css';
import SellerMasterLayout from 'layouts/SellerMasterLayout';
import { FaEye, FaEyeSlash, FaLock, FaSave, FaTimes } from 'react-icons/fa';
import AppContext from 'context/AppContext';
import axios from 'axios';

const SellerProfile = () => {

  /* ─── State ─── */
  const [profileData, setProfileData] = useState([]);
  const [tempData, setTempData] = useState({});
  const { loggedInSeller, setLoggedInSeller, baseUrlForFiles, baseUrl, authToken } = useContext(AppContext);

  const updateProfile = () => {

    // Basic validation pehle
    if (!loggedInSeller?.id) {
      alert("Seller ID missing hai. Dobara login karke try karo.");
      return;
    }

    const formData = new FormData();

    formData.append("id", loggedInSeller.id);
    formData.append("firstName", tempData.firstName || "");
    formData.append("lastName", tempData.lastName || "");
    formData.append("email", tempData.email || "");
    formData.append("phonenumber", tempData.phonenumber || "");
    formData.append("location", tempData.location || "");

    axios.post(
      `${baseUrl}/seller/profile/updateProfile`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {

        console.log("UPDATE RESPONSE:", response.data);

        const data = response.data;

        if (!data?.success) {
          alert(data?.message || "Profile update failed.");
          return;
        }

        // Agar backend ne seller object nahi bheja, to
        // purane loggedInSeller mein sirf tempData ke fields merge kar do
        // taake UI turant update ho jaye aur crash na ho
        const updatedSeller = data.seller
          ? data.seller
          : {
            ...loggedInSeller,
            firstName: tempData.firstName,
            lastName: tempData.lastName,
            email: tempData.email,
            phonenumber: tempData.phonenumber,
            location: tempData.location,
          };

        setLoggedInSeller(updatedSeller);
        localStorage.setItem("loggedInSeller", JSON.stringify(updatedSeller));

        setEditingSections(prev => ({
          ...prev,
          personal: false
        }));

        setTempData({});

        setShowSuccess(true);
        setTimeout(() => {
          setShowSuccess(false);
        }, 3000);

      })
      .catch((error) => {
        console.log(error.response?.data || error);
        alert(
          error.response?.data?.message ||
          "Profile update failed."
        );
      });
  };
  const [editingSections, setEditingSections] = useState({
    personal: false,
    business: false,
    // account: false
  });


  const [showSuccess, setShowSuccess] = useState(false);

  /* ─── Change Password Modal State ─── */
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const getProfileImageUrl = (image) => {
    if (!image) return "/default-avatar.png";

    if (image.startsWith("http")) return image;

    return `${baseUrlForFiles.replace(/\/$/, "")}/${image.replace(/^\//, "")}`;
  };

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });


  const changePassword = () => {

    const formData = new FormData();

    formData.append(
      "currentPassword",
      passwordData.currentPassword
    );

    formData.append(
      "newPassword",
      passwordData.newPassword
    );

    formData.append(
      "confirmPassword",
      passwordData.confirmPassword
    );

    axios.post(
      `${baseUrl}/seller/auth/changePassword`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {

        console.log(response.data);

        if (response.data.success) {

          alert(response.data.message);

          closePasswordModal();

          setPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
          });
        }

      })
      .catch((error) => {

        console.log(
          error.response?.data || error
        );

        alert(
          error.response?.data?.message ||
          "Password change failed."
        );
      });
  };

  /* ─── Profile Handlers ─── */
  const handleEdit = (section) => {
    setTempData({
      firstName: loggedInSeller?.firstName || "",
      lastName: loggedInSeller?.lastName || "",
      email: loggedInSeller?.email || "",
      phonenumber: loggedInSeller?.phonenumber || "",
      location: loggedInSeller?.location || "",
    });

    setEditingSections(prev => ({
      ...prev,
      [section]: true
    }));
  };
  const handleCancel = section => {
    setEditingSections(prev => ({ ...prev, [section]: false }));
    // setTempData({});
  };
  const handleChange = (field, value) => {
    setTempData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // const handleChange = (field, value) =>
  //   setTempData(prev => ({ ...prev, [field]: value }));


  const handleAvatarChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (!file.type.startsWith("image/")) {
      alert("Please select an image file.");
      e.target.value = "";
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Image size should be less than 5MB.");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("profileImage", file);

    axios.post(
      `${baseUrl}/seller/profile/updateProfileImage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
      .then((response) => {
        console.log("SELLER PROFILE IMAGE RESPONSE:", response.data);

        if (response.data.success) {
          const updatedSeller = {
            ...loggedInSeller,
            ...response.data.seller,
            profileImage:
              response.data.seller?.profileImage ||
              response.data.profileImage,
          };

          setLoggedInSeller(updatedSeller);

          localStorage.setItem(
            "loggedInSeller",
            JSON.stringify(updatedSeller)
          );

          localStorage.setItem(
            "sellerProfile",
            JSON.stringify(updatedSeller)
          );

          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
          }, 3000);
        } else {
          alert(response.data.message || "Profile image upload failed.");
        }
      })
      .catch((error) => {
        console.error(
          "SELLER PROFILE IMAGE ERROR:",
          error.response?.data || error
        );

        alert(
          error.response?.data?.message ||
          "Unable to upload seller profile picture."
        );
      })
      .finally(() => {
        e.target.value = "";
      });
  };

  // const displayData = section =>
  //   editingSections[section] ? tempData : loggedInSeller;

  /* ─── Password Modal Handlers ─── */
  const openPasswordModal = () => {
    setIsPasswordModalOpen(true);
    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
  };

  const closePasswordModal = () => {
    setIsPasswordModalOpen(false);
    setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    setShowCurrentPassword(false);
    setShowNewPassword(false);
    setShowConfirmPassword(false);
  };

  const handlePasswordChange = (field, value) => {
    setPasswordData(prev => ({ ...prev, [field]: value }));
  };

  const handlePasswordSubmit = () => {
    if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
      alert('Please fill all password fields');
      return;
    }
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      alert('New password and confirm password do not match');
      return;
    }
    if (passwordData.newPassword.length < 8) {
      alert('Password must be at least 8 characters long');
      return;
    }
    closePasswordModal();
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  /* ─── Reusable field ─── */
  const Field = ({ section, field, label, type = 'text', icon: Icon, readOnly = false }) => (
    <div className="sp-info-item">
      {Icon && <span className="sp-field-icon"><Icon size={14} /></span>}
      <label className="sp-info-label">{label}</label>
      {editingSections[section] && !readOnly ? (
        <input
          type={type}
          // value={displayData(section)[field] ?? ''}
          // onChange={e => handleChange(field, e.target.value)}
          className="sp-info-input"
        />
      ) : (
        <p className="sp-info-value">{loggedInSeller[field]}</p>
      )}
    </div>
  );



  /* ══════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════ */
  return (
    <SellerMasterLayout pageTitle="My Profile">

      {/* ── Toast ── */}
      {showSuccess && (
        <div className="sp-toast">
          <FiCheck size={16} />
          <span>Profile updated successfully!</span>
        </div>
      )}

      <div className="seller-profile-page">

        {/* ── Page heading ── */}
        <div className="sp-page-header">
          <div>
            {/* <h1 className="sp-page-title">Seller Profile</h1> */}
            {/* <p className="sp-page-subtitle">Manage your personal and business information</p> */}
          </div>
          <button className="sp-back-btn" onClick={() => window.history.back()}>
            <FiArrowLeft size={16} /> Back
          </button>
        </div>
        {/* ── Profile hero card ── */}
        <div className="sp-hero-card">
          <div className="sp-hero-bg" />
          <div className="sp-avatar-section">
            <div className="sp-avatar-wrapper">
              <img
                src={
                  loggedInSeller?.profileImage
                    ? `${baseUrlForFiles.replace(/\/$/, "")}/${loggedInSeller.profileImage.replace(/^\//, "")}`
                    : "/default-avatar.png"
                }
                alt={`${loggedInSeller?.firstName || ""} ${loggedInSeller?.lastName || ""}`}
                className="sp-avatar"
              />
              <label className="sp-avatar-upload-btn" title="Change photo">
                <FiCamera size={16} />
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  style={{ display: 'none' }}
                />
              </label>
              {profileData.kycStatus === 'Verified' && (
                <span className="sp-verified-badge" title="KYC Verified">
                  <FiShield size={12} />
                </span>
              )}
            </div>

            <div className="sp-hero-info">
              <div className="sp-kyc-pill">
                <FiShield size={11} />
                {loggedInSeller?.kycStatus}
              </div>
              <h2 className="sp-hero-name">
                {loggedInSeller?.firstName} {loggedInSeller?.lastName}
              </h2>
              {/* <p className="sp-hero-role">{loggedInSeller.role}</p> */}
              <div className="sp-hero-meta">
                {/* <span><FiMapPin size={13} /> {loggedInSeller.city}, {loggedInSeller.country}</span> */}
                <span><FiMapPin size={13} />, {loggedInSeller?.location}</span>
              </div>
            </div>
          </div>

          {/* ── Change Password Button — hero card top right ── */}
          <button className="sp-change-password-btn" onClick={openPasswordModal}>
            <FaLock size={13} /> Change Password
          </button>

          {/* Quick stats — commented out same as original
          <div className="sp-hero-stats"> ... </div> */}
        </div>

        {/* ── Cards grid ── */}
        <div className="sp-cards-grid">
          <div className="sp-section-card">
            <div className="sp-section-header">
              <h3 className="sp-section-title">Personal Information</h3>
              {!editingSections.personal ? (
                <button
                  className="sp-edit-btn"
                  onClick={() => handleEdit('personal')}
                >
                  <FiEdit2 size={16} />
                  Edit
                </button>
              ) : (
                <div className="sp-edit-actions">
                  <button
                    className="sp-cancel-btn"
                    onClick={() => handleCancel('personal')}
                  >
                    <FiX size={16} />
                    Cancel
                  </button>
                  <button
                    className="sp-save-btn"
                    onClick={updateProfile}
                  >
                    <FiSave size={16} />
                    Save
                  </button>
                </div>
              )}
            </div>

            <div className="sp-section-content">
              <div className="sp-info-grid">

                {/* First Name */}
                <div className="sp-info-item">

                  <label className="sp-info-label">
                    First Name
                  </label>

                  {editingSections.personal ? (

                    <input
                      type="text"
                      value={tempData.firstName || ""}
                      onChange={(e) =>
                        handleChange("firstName", e.target.value)
                      }
                      className="sp-info-input"
                    />

                  ) : (

                    <p className="sp-info-value">
                      {loggedInSeller?.firstName}
                    </p>

                  )}

                </div>

                {/* Last Name */}
                <div className="sp-info-item">

                  <label className="sp-info-label">
                    Last Name
                  </label>

                  {editingSections.personal ? (

                    <input
                      type="text"
                      value={tempData.lastName || ""}
                      onChange={(e) =>
                        handleChange("lastName", e.target.value)
                      }
                      className="sp-info-input"
                    />

                  ) : (

                    <p className="sp-info-value">
                      {loggedInSeller?.lastName}
                    </p>

                  )}

                </div>

                {/* City */}
                <div className="sp-info-item">

                  <label className="sp-info-label">
                    Location
                  </label>

                  {editingSections.personal ? (

                    <input
                      type="text"
                      value={tempData.location || ""}
                      onChange={(e) =>
                        handleChange("location", e.target.value)
                      }
                      className="sp-info-input"
                    />

                  ) : (

                    <p className="sp-info-value">
                      {loggedInSeller?.location}
                    </p>

                  )}

                </div>

                {/* Email */}
                <div className="sp-info-item">

                  <label className="sp-info-label">
                    Email
                  </label>

                  {editingSections.personal ? (

                    <input
                      type="email"
                      value={tempData.email || ""}
                      onChange={(e) =>
                        handleChange("email", e.target.value)
                      }
                      className="sp-info-input"
                    />

                  ) : (

                    <p className="sp-info-value">
                      {loggedInSeller?.email}
                    </p>

                  )}

                </div>

                {/* Phone Number */}
                <div className="sp-info-item">

                  <label className="sp-info-label">
                    Phone Number
                  </label>

                  {editingSections.personal ? (

                    <input
                      type="tel"
                      value={tempData.phonenumber || ""}
                      onChange={(e) =>
                        handleChange("phonenumber", e.target.value)
                      }
                      className="sp-info-input"
                    />

                  ) : (

                    <p className="sp-info-value">
                      {loggedInSeller?.phonenumber}
                    </p>

                  )}

                </div>



              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ══════════════════════════════════════════
          CHANGE PASSWORD MODAL
      ══════════════════════════════════════════ */}
      {isPasswordModalOpen && (
        <div className="sp-modal-overlay" onClick={closePasswordModal}>
          <div className="sp-modal" onClick={e => e.stopPropagation()}>

            {/* Modal Header */}
            <div className="sp-modal-header">
              <h3 className="sp-modal-title">
                <FaLock size={16} /> Change Password
              </h3>
              <button className="sp-modal-close-btn" onClick={closePasswordModal}>
                <FaTimes />
              </button>
            </div>

            {/* Modal Body */}
            <div className="sp-modal-body">
              <form className="sp-password-form" onSubmit={e => e.preventDefault()}>

                {/* Current Password */}
                <div className="sp-password-group">
                  <label className="sp-password-label">Current Password</label>
                  <div className="sp-password-input-wrapper">
                    <input
                      type={showCurrentPassword ? 'text' : 'password'}
                      className="sp-password-input"
                      value={passwordData.currentPassword}
                      onChange={e => handlePasswordChange('currentPassword', e.target.value)}
                      placeholder="Enter current password"
                    />
                    <button
                      type="button"
                      className="sp-password-toggle"
                      onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    >
                      {showCurrentPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                {/* New Password */}
                <div className="sp-password-group">
                  <label className="sp-password-label">New Password</label>
                  <div className="sp-password-input-wrapper">
                    <input
                      type={showNewPassword ? 'text' : 'password'}
                      className="sp-password-input"
                      value={passwordData.newPassword}
                      onChange={e => handlePasswordChange('newPassword', e.target.value)}
                      placeholder="Enter new password"
                    />
                    <button
                      type="button"
                      className="sp-password-toggle"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                {/* Confirm Password */}
                <div className="sp-password-group">
                  <label className="sp-password-label">Confirm Password</label>
                  <div className="sp-password-input-wrapper">
                    <input
                      type={showConfirmPassword ? 'text' : 'password'}
                      className="sp-password-input"
                      value={passwordData.confirmPassword}
                      onChange={e => handlePasswordChange('confirmPassword', e.target.value)}
                      placeholder="Confirm new password"
                    />
                    <button
                      type="button"
                      className="sp-password-toggle"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="sp-modal-actions">
                  <button
                    type="button"
                    className="sp-modal-cancel-btn"
                    onClick={closePasswordModal}
                  >
                    <FaTimes /> Cancel
                  </button>
                  <button
                    type="button"
                    className="sp-modal-save-btn"
                    onClick={changePassword}
                  >
                    <FaSave /> Save Password
                  </button>
                </div>

              </form>
            </div>
          </div>
        </div>
      )}

    </SellerMasterLayout>
  );
};

export default SellerProfile;
